import type { RouteRecordRaw } from 'vue-router';
import { mealVouchersRoutesDictionary } from './meal-vouchers-routes.dictionary.ts';

export const mealVouchersRoutesConfig: RouteRecordRaw = {
  ...mealVouchersRoutesDictionary.mealVouchers.root,
  redirect: { name: mealVouchersRoutesDictionary.mealVouchers.movements.name },
  children: [
    {
      ...mealVouchersRoutesDictionary.mealVouchers.movements,
      component: () =>
        import('../pages/Movements/MealVoucherMovementsPage.vue'),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.cardOrders,
      component: () =>
        import('../pages/CardOrders/MealVoucherCardOrdersPage.vue'),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.cardOrdersDetail,
      props: true,
      component: () =>
        import('../pages/CardOrders/Detail/MealVoucherCardOrderDetailPage.vue'),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.bankTransfers,
      component: () =>
        import('../pages/BankTransfers/MealVoucherBankTransfersPage.vue'),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.bankTransfersAssociateOrders,
      component: () =>
        import(
          '../pages/BankTransfers/AssociateOrders/MealVoucherAssociateOrdersPage.vue'
        ),
    },
  ],
};
